var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSignup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.758,
    height: 30.994,
    viewBox: "0 0 33.758 30.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_1",
    "data-name": "Logo 1",
    transform: "translate(-80 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12431",
    "data-name": "Group 12431",
    transform: "translate(80 148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11172",
    "data-name": "Group 11172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11171",
    "data-name": "Group 11171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M212.79,76.72h9.252v8.646Z",
    transform: "translate(-188.408 -76.72)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M167.585,76.72l15.044,13.7v5.692L161.09,76.72Z",
    transform: "translate(-148.996 -76.72)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M109.68,76.72h6.144l27.615,25.017v5.977Z",
    transform: "translate(-109.68 -76.72)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M109.68,108.679l2.895-3.059,2.826,3.059L109.68,114.8Z",
    transform: "translate(-109.68 -96.777)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M109.68,141.95,119,132.27l2.9,2.847-12.219,12.4Z",
    transform: "translate(-109.68 -117.093)",
    fill: "#021433"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11170",
    "data-name": "Group 11170",
    transform: "translate(12.075 21.884)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 3.603,
    height: 3.558,
    transform: "translate(5.121 4.984)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 3.603,
    height: 3.558,
    transform: "translate(0 4.984)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 3.603,
    height: 3.558,
    transform: "translate(5.121)",
    fill: "#021433"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 3.603,
    height: 3.558,
    fill: "#021433"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignup);
export default __webpack_public_path__ + "static/media/ICON_Signup.c8444a4c60a54ecf0cb9b4f514d431b7.svg";
export { ForwardRef as ReactComponent };